<template>
<keep-alive>
            <div v-for="add in ads" :key="add.id">
                <div v-html="add.adcode"></div>
                

            </div>
            <div id="gist">
                <adsense
  ad-client="ca-pub-0756076699379568"
  ad-slot="2172411856"
  ad-style="display: block"
  ad-format="auto">
</adsense>
            </div>
            <!-- <template> -->
            <script2 type="text/javascript" id="5y3ycw8b5a_6_25">
(function() {
var e=document.createElement('script');
e.src='https://graphics.adrecord.com/5y3ycw8b5a_6_25.js';
var s=document.getElementsByTagName('body')[0]; s.appendChild(e);
})();
</script2>
<!-- <template> -->
</keep-alive>
</template>

<script>
import axios from "axios";
import store from "../store";
export default {
    props: ["theme"],
    data: function() {
        return {
            store: store,
            ads : null
        };
    },
    mounted: function () {
    //     let scriptTag = document.createElement('script')
    //     scriptTag.async = true
    //     scriptTag.setAttribute('id', '5y3ycw8b5a_6_25')
    //     scriptTag.onload = () => {
    //     (function(){
    //     var e=document.createElement('script');
    //     e.src='https://graphics.adrecord.com/5y3ycw8b5a_6_25.js';
    //     var s=document.getElementsByTagName('body')[0]; s.appendChild(e);
    //     })();
    //     }
    //     document.getElementById('static').appendChild(scriptTag)
    },
    created: async function() {
        if (this.theme) {
            var resp = await axios.get(
                `${this.store.state.baseURL}getadds/${this.theme}`
            );
        } else resp = await axios.get(`${this.store.state.baseURL}getadds/11`);
        this.ads = resp.data.add
    }
};
</script>

<style></style>
